export default "__VITE_ASSET__3CdKVCqI__"